export default "__VITE_ASSET__BGmXOlhR__"